import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

const HeroContentContainer = styled(Box)(({ theme }) => ({
  zIndex: 1,
  display: "flex !important",
  position: "static !important",
  alignItems: "center",
  gap: theme.spacing(6),

  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },

  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(2),
    padding: theme.spacing(4, 0, 0),
  },
}));

const HeroContentTitle = styled(Typography)(({ theme }) => ({
  display: "flex",
  color: "white",
  maxWidth: "min-content",
  textAlign: "center",
  textShadow: "5px 5px 5px black",

  "& h2": {
    fontFamily: "Source Sans Pro",
  },

  [theme.breakpoints.down("lg")]: {
    maxWidth: "max-content",
    fontSize: 30,
  },
}));

const HeroContentAboutContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundImage:
    "linear-gradient(rgba(23,37,49,0.75), rgba(69,111,147,0.75))",
  border: "solid 2px #172531",
  borderRadius: 20,
  transition: ["transform"],
  transitionDuration: "250ms",
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  backdropFilter: "blur(2px)",
  transform: "translateZ(0)",
  willChange: "transform",

  "& div img": {
    transitionDuration: "250ms",
    transform: "translateZ(0)",
    willChange: "transform",
  },

  "&:hover, :focus": {
    transform: "scale(1.05)",

    "& div img": {
      transform: "scale(1.05)",
    },
  },

  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0, 1, 2),
  },
}));

const HeroContentAboutImgWrapper = styled(Box)(({ theme }) => ({
  maxHeight: 300,
  maxWidth: 300,
  minHeight: 300,
  minWidth: 300,
  objectFit: "cover",
  borderRadius: 20,
  border: "solid 2px #172531",
  overflow: "hidden",

  "& img": {
    height: "100%",
    width: "100%",
  },

  [theme.breakpoints.down("md")]: {
    maxWidth: "100px",
    maxHeight: "100px",
    minHeight: 100,
    minWidth: 100,
  },
}));

const MobileDescription = styled(Box)(({ theme }) => ({
  display: "none",
  flexDirection: "column",

  "& h3": {
    fontFamily: "Source Sans Pro",
    fontSize: 28,
    margin: theme.spacing(0, 0, 1),
  },

  "& p": {
    fontFamily: "Source Sans Pro",
    marginBottom: theme.spacing(1),
    fontSize: 14,
    fontWeight: "normal",
  },

  "& p:last-child": {
    marginBottom: 0,
  },

  [theme.breakpoints.down("md")]: {
    width: 175,
    minWidth: 175,
    margin: 0,
    paddingTop: 0,

    display: "flex",
    justifyContent: "center",
    color: "white",

    "& h3": {
      fontSize: 20,
    },

    "& p": {
      fontSize: 12,
    },
  },
}));

const HeroContentAboutDesc = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  color: "white",
  marginRight: theme.spacing(1),
  minWidth: 300,
  width: 300,
  padding: "10px 0 0 0",

  "& h3": {
    fontFamily: "Source Sans Pro",
    fontSize: 28,
    margin: theme.spacing(0, 0, 1),
  },

  "& p": {
    fontFamily: "Source Sans Pro",
    marginBottom: theme.spacing(1),
    fontSize: 14,
    fontWeight: "normal",
  },

  "& p:last-child": {
    marginBottom: 0,
  },

  [theme.breakpoints.down("md")]: {
    width: 250,
    minWidth: 250,
    margin: 0,
    paddingTop: 0,

    "& h3": {
      fontSize: 20,
    },

    "& p": {
      fontSize: 12,
    },
  },
}));

export {
  HeroContentContainer,
  HeroContentTitle,
  HeroContentAboutContainer,
  HeroContentAboutImgWrapper,
  HeroContentAboutDesc,
  MobileDescription,
};
